import useCreateUrl from "../../hooks/useCreateUrl.js";
import { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import useOfferCartOrderData from "../../hooks/useOfferCartOrderData.js";
import useGetSearchResultsBound from "../../hooks/useGetSearchResultsBound.js";
export default function useGoToFlightDetails() {
    const params = useParams();
    const { createUrl } = useCreateUrl();
    const history = useHistory();
    const offerCartOrderData = useOfferCartOrderData();
    const bound = useGetSearchResultsBound();
    return useCallback((flightToken, baseOffer, brandedFareIndex, outboundBrandedFareName, outboundBrandedFareTravellerPrice) => {
        const locationParams = location.search;
        const urlParams = new URLSearchParams(locationParams);
        const hasBrandedFareIndex = brandedFareIndex !== undefined && Number.isInteger(brandedFareIndex);
        urlParams.set("baseOfferToken", baseOffer.token);
        if (hasBrandedFareIndex && bound !== "outbound") {
            urlParams.set("brandedFareIndex", brandedFareIndex.toString());
        }
        offerCartOrderData.set(flightToken, { offer: flightToken, parentOfferToken: baseOffer.token });
        let url = `/flights/${params.airports}/${flightToken}/?${urlParams}`;
        if (bound === "outbound") {
            const outboundToken = baseOffer.outboundFlightInfo?.token;
            if (outboundToken) {
                urlParams.set("outboundBrandedFareToken", flightToken);
                if (hasBrandedFareIndex) {
                    urlParams.set("outboundBrandedFareIdx", brandedFareIndex.toString());
                    if (outboundBrandedFareName) {
                        urlParams.set("outboundBrandedFareName", outboundBrandedFareName);
                        const priceStr = outboundBrandedFareTravellerPrice
                            ? `${outboundBrandedFareTravellerPrice.units}.${outboundBrandedFareTravellerPrice.nanos}`
                            : "0.0";
                        urlParams.set("outboundBrandedFareTravellerPrice", priceStr);
                    }
                    const inboundFlightsCount = baseOffer.outboundFlightInfo?.inboundFlightsCount;
                    if (typeof inboundFlightsCount === "number" && inboundFlightsCount > 0) {
                        urlParams.set("limit", inboundFlightsCount.toString());
                    }
                }
                url = `/flights/${params.airports}/inbound/${outboundToken}/?${urlParams}`;
            }
        }
        else if (bound && params.outboundToken) {
            url = `/flights/${params.airports}/inbound/${params.outboundToken}/${flightToken}/?${urlParams}`;
        }
        history.push(createUrl(url));
    }, [offerCartOrderData, params.airports, params.outboundToken, bound, history, createUrl]);
}
